export default __webpack_public_path__ + "static/circles-bg-401cad04364e2ea38e11bbbf0380ea0c.png";